import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import 'fast-text-encoding';
import 'svg-classlist-polyfill';

if (!Element.prototype.matches) {
  // @ts-expect-error polyfill
  Element.prototype.matches = Element.prototype.msMatchesSelector;
}
